import * as React from 'react'
import clsx from 'clsx'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from './Container'
import styles from './CtaBand.module.css'

export type CtaBandAction = { label: string; href: string }

export type CtaBandProps = {
  title: React.ReactNode
  lede?: React.ReactNode
  /** Rendered left-to-right; the first is the solid ink button, the rest are outlined. */
  actions: CtaBandAction[]
  className?: string
  /**
   * Called when any action is clicked, for pages that report the band as a conversion point. It is
   * deliberately not told WHICH action: no caller renders more than one, and a signature that
   * cannot tell them apart forces the question to be revisited if that changes.
   */
  onActionClick?: () => void
}

/**
 * Closing accent band: an oversized display title on the accent color inside a bold ink border, with
 * one or more round buttons. Shared by the static pages that end on a call to action.
 */
export function CtaBand({ title, lede, actions, className, onActionClick }: CtaBandProps): React.ReactElement {
  return (
    <section className={clsx(styles.cta, className)}>
      <Container>
        <div className={styles.cta__band}>
          <h2 className={styles.cta__title}>{title}</h2>
          {lede !== undefined ? <p className={styles.cta__lede}>{lede}</p> : null}
          <div className={styles.cta__actions}>
            {actions.map((action, index) => (
              <plume.RoundButton
                key={action.href}
                as="a"
                href={action.href}
                color="black"
                kind={index === 0 ? 'primary' : 'secondary'}
                size="big"
                onClick={onActionClick}
              >
                {action.label}
              </plume.RoundButton>
            ))}
          </div>
        </div>
      </Container>
    </section>
  )
}
